import {
  GET_VACCINECENTERS,
  GET_VACCINECENTER,
  SET_MAP,
  ADD_VACCINECENTER,
  DELETE_VACCINECENTER,
} from "./types";
import api from "../utils/api";
import { setAlert } from "./alertActions";

// Add Vaccine Center
export const addVaccineCenter = (formData) => async (dispatch) => {
  try {
    const res = await api.post("/vaccinecenters", formData);

    dispatch({
      type: ADD_VACCINECENTER,
      payload: res.data,
    });

    dispatch(setAlert("VaccineCenter Created", "success"));
  } catch (err) {
    dispatch({
      type: VACCINECENTER_ERROR,
    });
    console.log(err);
  }
};

// Update Vaccine Center
export const updateVaccineCenter = (vaccinecenter) => async (dispatch) => {
  try {
    const res = await api.put(
      `/vaccinecenters/${vaccinecenter.id}`,
      vaccinecenter
    );
    dispatch({
      type: UPDATE_VACCINECENTER,
      payload: res.data,
    });
  } catch (err) {
    // dispatch({
    //   type: DATAPOINT_ERROR,
    //   payload: { msg: err.response.statusText, status: err.response.status },
    // });
    console.log(err);
  }
};

// Get vaccinecenter
export const getVaccineCenter = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/vaccinecenters/${id}`);

    dispatch({
      type: GET_VACCINECENTER,
      payload: res.data,
    });
  } catch (err) {
    // dispatch({
    //   type: DATAPOINT_ERROR,
    //   payload: { msg: err.response.statusText, status: err.response.status },
    // });
    console.log(err);
  }
};

// Delete vaccinecenter
export const deleteVaccineCenter = (id) => async (dispatch) => {
  try {
    await api.delete(`/vaccinecenters/${id}`);

    dispatch({
      type: DELETE_VACCINECENTER,
      payload: id,
    });

    dispatch(setAlert("VaccineCenter Removed", "success"));
  } catch (err) {
    // dispatch({
    //   type: DATAPOINT_ERROR,
    //   payload: { msg: err.response.statusText, status: err.response.status },
    // });
    console.log(err);
  }
};

export const getVaccineCenters = () => async (dispatch) => {
  try {
    const res = await api.get("/vaccinecenters");
    dispatch({
      type: GET_VACCINECENTERS,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getVaccineCentersByArea = (code, miles) => async (dispatch) => {
  try {
    const res = await api.get(`/vaccinecenters/radius/${code}/${miles}`);
    dispatch({
      type: GET_VACCINECENTERS,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const filterVaccineCenters = (
  appointment,
  walkIn,
  driveThru,
  older75,
  eduChildCare,
  protServ,
  popUp,
  regular
) => async (dispatch) => {
  try {
    // Check for appointment
    if (appointment) {
      var appointmentF = "&appointment=true";
    } else {
      appointmentF = "";
    }
    // Check for walkIn
    if (walkIn) {
      var walkInF = "&walkIn=true";
    } else {
      walkInF = "";
    }
    // Check for driveThru
    if (driveThru) {
      var driveThruF = "&driveThru=true";
    } else {
      driveThruF = "";
    }
    // Check for older75
    if (older75) {
      var older75F = "&older75=true";
    } else {
      older75F = "";
    }
    // Check for eduChildCare
    if (eduChildCare) {
      var eduChildCareF = "&eduChildCare=true";
    } else {
      eduChildCareF = "";
    }
    // Check for protServ
    if (protServ) {
      var protServF = "&protServ=true";
    } else {
      protServF = "";
    }
    // Check for regular and popup
    if (regular && popUp) {
      var permanentLocF = "";
    } else if (!regular && !popUp) {
      permanentLocF = "";
    } else if (regular) {
      permanentLocF = "&permanentLocation=false";
    } else {
      permanentLocF = "&permanentLocation=true";
    }
    const res = await api.get(
      `/vaccinecenters/?sort=""${appointmentF}${walkInF}${driveThruF}${older75F}${eduChildCareF}${protServF}${permanentLocF}`
    );
    dispatch({
      type: GET_VACCINECENTERS,
      payload: res.data.data,
    });
    console.log(
      `/vaccinecenters/?sort=""${appointmentF}${walkInF}${driveThruF}${older75F}${eduChildCareF}${protServF}${permanentLocF}`
    );
  } catch (error) {
    console.log(error);
  }
};

export const setMap = (center) => async (dispatch) => {
  try {
    const res = await center;
    dispatch({
      type: SET_MAP,
      payload: res,
    });
  } catch (error) {
    console.log(error);
  }
};
